class StepLearningGoalsController {

}

export default StepLearningGoalsController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/stepLearningGoalsController.js